export default "__VITE_ASSET__C_zGizHT__"